import { defineStore } from 'pinia'
import { LiveDrop } from '@/services/models/models'

interface StatsState {
  generalStats?:
    | {
        users?: number
        caseOpenings?: number
        arenaRolls?: number
        arenaRoomCreated?: number
        arenaRoomsCreated?: number
        upgrades?: number
        contracts?: number
      }
    | undefined
  onlineUsers?: number
  drops: LiveDrop[]
  luckyDrops: LiveDrop[]
}

export const useStatsStore = defineStore('stats', {
  state: (): StatsState => ({
    generalStats: undefined,
    onlineUsers: 0,
    drops: [],
    luckyDrops: [],
  }),
  actions: {
    setOnlineUsers(count: number) {
      this.onlineUsers = count
    },
    setGeneralStats(stats: StatsState['generalStats']) {
      this.generalStats = stats
    },
    setDrops(drops: LiveDrop[]) {
      this.drops = drops
    },
    setLuckyDrops(drops: LiveDrop[]) {
      this.luckyDrops = drops
    },
    addDrop({ drop, game }: { drop: LiveDrop; game: string }) {
      // put new drop at the front; keep at most 30
      this.drops = [drop, ...this.drops].slice(0, 30)
      this.generalStats = {
        ...this.generalStats,
        caseOpenings: (this.generalStats?.caseOpenings ?? 0) + 1,
      }
    },
    addDrops({ drops, game }: { drops: LiveDrop[]; game: string }) {
      // prepend many; cap to 30 (safe even if drops.length > 30)
      this.drops = [...drops, ...this.drops].slice(0, 30)
      this.generalStats = {
        ...this.generalStats,
        caseOpenings: (this.generalStats?.caseOpenings ?? 0) + drops.length,
      }
    },
  },
})
